<template>
    <el-input :value="value"
              :disabled="disabled"
              v-mask="priceMask"
              type="text"
              class="el-input--underline el-input--underline-center"
              size="mini"
              @input="(value) => $emit('input', value)">
        <span v-text="value"></span>
    </el-input>
</template>

<script>
  import {mask} from '../../../directives';

  export default {
    name: 'InputMaskedPrice',
    props: {
      price: {
        required: true,
      },
      disabled: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    directives: {
      mask,
    },
    computed: {
      value() {
        if (typeof this.price === 'number') {
          return this.price.toFixed(2);
        }
        return this.price;
      },
    },
    data() {
      return {
        priceMask: {
          alias: 'currency',
          prefix: '$',
          rightAlign: false,
          showMaskOnHover: false,
          autoUnmask: true,
          clearIncomplete: true,
        },
      };
    },
  };
</script>
